import { useCallback } from 'react';
import { useTranslationStore } from 'app/stores/translationStore';

export type TranslateFn = (key: string, params?: Record<string, string>) => string;

export const useTranslations = () => {
  const translations = useTranslationStore(state => state.translations);
  const loading = useTranslationStore(state => state.loading);
  const error = useTranslationStore(state => state.error);
  const fetchTranslations = useTranslationStore(
    state => state.fetchTranslations
  );
  const setLang = useTranslationStore(state => state.setLang);

  const t = useCallback<TranslateFn>(
    (key, params = {}) => {
      const value = translations[key] || key;
      return Object.entries(params).reduce(
        (acc, [k, v]) => acc.replace(new RegExp(`{${k}}`, 'g'), v),
        value
      );
    },
    [translations]
  );

  return { t, loading, error, fetchTranslations, setLang };
};
